import common from '@/sui/data/sheets/convert/common'
import fields from '@/sui/data/sheets/edit/fields'

const pneumopathies = (function () {
  const all = [
    { field: fields.pneumopathy },
    { field: fields.episod, special: 'date' },
    { field: fields.diagnosis }
  ]

  const v2 = [
    { field: fields.diagDate, special: 'date' },
    { field: fields.covidStatus },
    { field: fields.origin }
  ]

  return {
    v1: [...all, common.specialMicroOrgs.virus.v1],
    v2: [...all, ...v2, common.specialMicroOrgs.virus.v1],
    v3: [...all, ...v2, common.specialMicroOrgs.virus.v2],
    v4: [...all, ...v2, common.specialMicroOrgs.virus.v3]
  }
})()

const reaInfCatheters = (function () {
  const all = [
    { field: fields.central },
    { field: fields.insertion, special: 'date' },
    { field: fields.insertionSite },
    { field: fields.removed },
    { field: fields.removal, special: 'date' },
    { field: fields.laboratory },
    { field: fields.isColIlcBlc },
    { field: fields.colIlcBlc, special: 'date' }
  ]

  const v1 = [
    { field: fields.catheterType }
  ]

  const v2 = [
    { field: fields.diagDate, special: 'date' },
    { field: fields.lipids },
    { field: fields.divDiag },
    { field: fields.covidStatus },
    common.addV2(fields.catheterType)
  ]

  const v3 = [
    { field: fields.previousManip },
    { field: fields.previousManipType },
    { field: fields.previousManipDate, special: 'date' },
    { field: fields.clinicalSigns },
    { field: fields.bioSigns },
    { field: fields.adaptedAntibio },
    { field: fields.twoHemocs }
  ]

  const v4 = [
    { field: fields.origin, cfield: fields.bactOrigin }
  ]

  const antibio = {
    v1: common.specialMicroOrgs.noVirus.v1,
    v2: common.specialMicroOrgs.noVirus.v2,
    v3: common.specialMicroOrgs.noVirus.v3
  }

  return {
    v1: [...all, antibio.v1, ...v1],
    v2: [...all, antibio.v1, ...v2],
    v3: [...all, antibio.v1, ...v2, ...v3],
    v4: [...all, antibio.v1, ...v2, ...v3, ...v4],
    v5: [...all, antibio.v2, ...v2, ...v3, ...v4],
    v6: [...all, antibio.v3, ...v2, ...v3, ...v4]
  }
})()

const sheet = (function () {
  const all = [
    { field: fields.sheetNumber, special: 'numeric' },
    { field: fields.uf },
    { field: fields.birthdate, special: 'date' },
    { field: fields.sex },
    { field: fields.entrydate, special: 'date' },
    { field: fields.origin, cfield: fields.patientOrigin },
    { field: fields.trauma },
    { field: fields.diagnosis },
    { field: fields.immuno },
    { field: fields.antibio },
    { field: fields.mainSeverity, special: 'mainSeverity' },
    { field: fields.otherSeverity, special: 'otherSeverity' },
    { field: fields.portageBmrBhre },
    { field: fields.ecmo },
    { field: fields.intubated },
    { field: fields.intubStart, special: 'date' },
    { field: fields.reintubated },
    { field: fields.intubEnd, special: 'date' },
    { field: fields.urinary },
    { field: fields.urinaryStart, special: 'date' },
    { field: fields.urinaryEnd, special: 'date' },
    { field: fields.dead },
    { field: fields.death, special: 'date' },
    { field: fields.exit, special: 'date' }
  ]

  const v1 = [
    { field: fields.unitType, special: 'unitType' },
    { field: fields.catheterArray, array: reaInfCatheters.v1 },
    { field: fields.bactArray, array: common.bacteremia.v1 },
    { field: fields.pneumopathies, array: pneumopathies.v1 },
    { field: fields.bmrBhreMicroOrg }
  ]

  const c = [
    { field: fields.bmrBhreMicroOrgs, array: common.bmrBhreMicroOrgs },
    { field: fields.cancer }
  ]

  const v2 = [
    { field: fields.unitType, special: 'unitType' },
    { field: fields.catheterArray, array: reaInfCatheters.v2 },
    { field: fields.bactArray, array: common.bacteremia.v2 },
    { field: fields.pneumopathies, array: pneumopathies.v2 }
  ]

  const v3 = [
    { field: fields.unitType, special: 'unitType' },
    { field: fields.covidStatus },
    { field: fields.catheterArray, array: reaInfCatheters.v3 },
    { field: fields.bactArray, array: common.bacteremia.v3 },
    { field: fields.pneumopathies, array: pneumopathies.v2 }
  ]

  const v4 = [
    { field: fields.unitType, special: 'unitType' },
    { field: fields.covidStatus },
    { field: fields.catheterArray, array: reaInfCatheters.v4 },
    { field: fields.bactArray, array: common.bacteremia.v3 },
    { field: fields.pneumopathies, array: pneumopathies.v2 }
  ]

  const v5 = [
    { field: fields.unitType, special: 'unitType' },
    { field: fields.covidStatus },
    { field: fields.catheterArray, array: reaInfCatheters.v5 },
    { field: fields.bactArray, array: common.bacteremia.v4 },
    { field: fields.pneumopathies, array: pneumopathies.v3 },
    { field: fields.bmi, special: 'numeric' }
  ]

  const v6 = [
    { field: fields.unitType, special: 'unitType_v2' },
    { field: fields.covidStatus },
    { field: fields.catheterArray, array: reaInfCatheters.v5 },
    { field: fields.bactArray, array: common.bacteremia.v4 },
    { field: fields.pneumopathies, array: pneumopathies.v3 },
    { field: fields.bmi, special: 'numeric' }
  ]

  const v7 = [
    { field: fields.unitType, special: 'unitType_v2' },
    { field: fields.covidStatus },
    { field: fields.catheterArray, array: reaInfCatheters.v6 },
    { field: fields.bactArray, array: common.bacteremia.v6 },
    { field: fields.pneumopathies, array: pneumopathies.v4 },
    { field: fields.bmi, special: 'numeric' }
  ]

  return {
    '2019': [...all, ...v1],
    '2020': [...all, ...c, ...v2],
    '2021': [...all, ...c, ...v3],
    '2022': [...all, ...c, ...v4],
    '2023': [...all, ...c, ...v5],
    '2024': [...all, ...c, ...v6],
    '2025': [...all, ...c, ...v7],
    '2026': [...all, ...c, ...v7]
  }
})()

export default sheet
